import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PermissionEnum, TransactionLogsContent } from '@ui/src';
import { useAppSelector } from '@store';
import useProblemIncomingTransaction from '../hooks/use-incoming';

const ProblemIncomingTransactionLogContentHOC = (): React.JSX.Element => {
  const { transactionId } = useParams();

  const { logs } = useAppSelector(
    (state) => state.customersProblemTransactions.incoming,
  );
  const { activePermissions } = useAppSelector((state) => state.root);

  const { getIncomingLogsAction, isLoadingLog } = useProblemIncomingTransaction(
    {
      transactionId,
    },
  );

  useEffect(() => {
    if (!logs && transactionId) {
      getIncomingLogsAction();
    }
  }, [getIncomingLogsAction, logs, transactionId]);

  return (
    <TransactionLogsContent
      isLoading={isLoadingLog}
      logs={logs}
      activePermission={activePermissions?.includes(
        PermissionEnum.TRANSACTION_QUEUE_ITEMS_INCOMING_LIST,
      )}
    />
  );
};

export default ProblemIncomingTransactionLogContentHOC;
